﻿export interface IComparisonConversionType {
    dash: boolean,
    dcn: boolean,
    nkr: boolean
}
